import AnimationEditor from './AnimationEditor';

export default AnimationEditor;
